// frontend/src/landing/sections/CaseStudyClinicSection.tsx

import Brand from "../components/Brand";
import Card from "../components/Card";
import Section from "../components/Section";

export default function CaseStudyClinicSection() {
  return (
    <Section
      id="praxis-klinik"
      eyebrow="Fallstudie"
      title="Klinik"
      badge="Echtbetrieb"
    >
      <p className="zg-text">
        Im Augenzentrum Lister Platz müssen Patientenversorgung, Weiterbildung 
        und Arbeitszeitwünsche in einem gemeinsamen Schichtplan zusammenpassen.
      </p>

      <p className="zg-text">
        Eine Ärztin bildete das Organisationswissen der Klinik 
        nach kurzer Einarbeitung selbstständig in <Brand /> ab.
      </p>

      <p className="zg-text">
        Mehrere Ziele wurden im neuen Plan 
        bei gleichbleibender Versorgungsqualität erreicht.  
      </p>

      <div className="zg-cards">
        <Card title="Gewünschter freier Tag">
          <p className="zg-text">
            Für eine Kollegin konnte erstmals ein bislang nicht realisierbarer
            freier Wochentag eingeplant werden.
          </p>
        </Card>

        <Card title="Mehr Weiterbildung">
          <p className="zg-text">
            Eine Assistenzärztin konnte häufiger Bereiche begleiten,
            die für ihre Weiterbildung relevant waren.
          </p>
        </Card>

        <Card title="Bessere Bündelung">
          <p className="zg-text">
            Die neue Abstimmung der Schichten eröffnete organisatorische und wirtschaftliche Möglichkeiten.
          </p>
        </Card>
      </div>

      <blockquote className="zg-quote">
        <p className="zg-quote-text">
          Ich bin immer wieder überrascht, wie viele Wünsche sich am Ende doch
          umsetzen lassen. Es lohnt sich daher, die Regeln sorgfältig zu formulieren. 
          Inzwischen bauen auch die Folgequartale auf diesem Regelwerk auf.
        </p>
        <footer className="zg-quote-author">
          Dr. Kathrin Köhler, Geschäftsführerin
        </footer>
      </blockquote>

      <p className="zg-footnote">
        <Brand /> schafft neue Spielräume, ohne die Vorgaben aufzuweichen.
      </p>
    </Section>
  );
}